import ContentSliderStyles from "@web-libs/ui/ui-components/slider/content-slider.module.css";
import {Container} from "@web-libs/ui/layout-components/container";
import {Text} from "@web-libs/ui/ui-components/typo/text";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";


export const ContentSliderEmpty = () => {
    const landingPageDict = useDictionaryContext().landingPage
    const className = `${ContentSliderStyles.contentSliderShared} ${ContentSliderStyles.contentSliderEmpty}`
    const classNameText = `${ContentSliderStyles.contentSliderEmptyText}`
    return (
        <Container className={className} padding={32}>
            <Text size={'md'} className={classNameText}>{landingPageDict.slider_empty_state}</Text>
        </Container>
    )
}
